export default "__VITE_ASSET__902962d3__"